export const validationErrors = {
  required: 'Это поле является обязательным.',
  incorrectFormat: 'Некорректный формат.',
  email: 'Неверный формат почтового адреса.',
  passwordMinLength: 'Минимальная длина пароля - 8 символов.',
  messageMinLength: 'Минимальная длина сообщения - 8 символов.',
};
